import React, { Component } from 'react';
import { t } from '../../../i18n';
import { Container, Row, Col, Alert } from 'reactstrap';

export default class AccessDeniedWarning extends Component {
    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <Alert color="danger" className="text-center">
                            {t('you_dont_have_access_to_this_application')}
                        </Alert>
                    </Col>
                </Row>
            </Container>
        );
    }
}
